/**
 * 字典数据组件（非字典组件）
 * @author xuyd
 * @date 2023-03-01
 */
import Dict from './Dict'

export default function (Vue, options) {
  // mixin处理
  Vue.mixin({
    data() {
      // 把dictType注入到data里面
      if (this.$options === undefined || !this.$options.dictTypes || this.$options.dictTypes.length <= 0) {
        return {}
      }
      const dict = new Dict(this);
      return {
        dict,
      }
    },
    created() {
      if (!this.dict || !(this.dict instanceof Dict)) {
        return
      }
      // 手动创建dict对象的场景，this.dict存在的，但是dictTypes可能不存在，此时也不初始化
      if (!this.$options.dictTypes) {
        return;
      }
      this.dict.init(this.$options.dictTypes, options);
    }
  });
}
